export default __webpack_public_path__ + "static/media/Vitae_TreasureHint.9fbe19d1.png";